export const setCookie = (cookieName, value) => {
  return new Promise((resolve, reject) => {
    localStorage.setItem(cookieName, value);

    resolve(true);
  });
};

export const getCookie = (cookieName) => {
  return localStorage.getItem(cookieName);
};

// const removeCookie = (cookieName) => {
//   return new Promise((resolve, reject) => {
//     localStorage.removeItem(cookieName);
//     resolve(true);
//   });
// };

// const clearSession = () => {
//   localStorage.clear();
// };

// const getCookieObj = (name) => {
//   return JSON.parse(localStorage.getItem(name) || "{}");
// };
